import { Component, inject } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { AppStore } from "./app.store";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, MatProgressSpinnerModule],
  styleUrl: "./app.component.scss",
  templateUrl: "./app.component.html",
})
export class AppComponent {
  appStore = inject(AppStore);
}
